import React, { ReactNode, useReducer } from "react";

import CartReducer from "./CartStoreReducer";
import { TCart } from "../types";

type TCartProvider = {
  config?: { type: string };
  children: ReactNode;
};

const emptyCartStore: TCart = { vehicles: [] };

export const CartStore = React.createContext<{
  state: TCart;
  dispatch: React.Dispatch<any>;
}>({
  state: emptyCartStore,
  dispatch: () => null,
});

const CartProvider = ({
  config = { type: "prod" },
  children,
}: TCartProvider) => {
  const [state, dispatch] = useReducer(CartReducer, emptyCartStore);
  React.useEffect(() => {
    getData(config)(dispatch);
  }, [config]);

  return (
    <CartStore.Provider value={{ state, dispatch }}>
      {children}
    </CartStore.Provider>
  );
};

const getData =
  ({ type }: { type: string }): any =>
  async (dispatch: any) => {
    switch (type) {
      default:
        dispatch({ type: "RESET_VEHICLES" });
    }
  };

export default CartProvider;
